/**
 *
 * Copyright 2020-2025 Splunk Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
import { diag } from '@opentelemetry/api';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { captureTraceParent } from '../servertiming';
export class SplunkFetchInstrumentation extends FetchInstrumentation {
    constructor(config = {}) {
        const origCustomAttrs = config.applyCustomAttributesOnSpan;
        config.applyCustomAttributesOnSpan = function (span, request, result) {
            // Temporary return to old span name until cleared by backend
            span.updateName(`HTTP ${(request.method || 'GET').toUpperCase()}`);
            span.setAttribute('component', 'fetch');
            if (span && result instanceof Response && result.headers) {
                const st = result.headers.get('Server-Timing');
                if (st) {
                    captureTraceParent(st, span);
                }
            }
            if (origCustomAttrs) {
                origCustomAttrs(span, request, result);
            }
        };
        super(config);
        const _superAddHeaders = this._addHeaders.bind(this);
        this._addHeaders = (options, spanUrl) => {
            // Fix: Fetch instrumentation currently can't handle headers array
            try {
                if (options.headers && Array.isArray(options.headers)) {
                    ;
                    options.headers = new Headers(options.headers);
                }
            }
            catch (error) {
                diag.error('Error fixing headers', error);
            }
            return _superAddHeaders(options, spanUrl);
        };
    }
    enable() {
        // Don't attempt in browsers where there's no fetch API
        if (!window.fetch) {
            return;
        }
        super.enable();
    }
}
//# sourceMappingURL=splunk-fetch-instrumentation.js.map